import { useScript } from "Hooks"

const BraspagAuthorize = () => {
  const [loadedConfig] = useScript('https://vertice-ds.s3.amazonaws.com/Assets/scripts/braspag-conf.js', { id: 'braspagConfig' }) //URL de DEV
  const [loadedAuthenticate] = useScript('https://premmiardev.blob.core.windows.net/braspag-debit/braspag-sa.js', { id: 'braspagSendAuthenticate' })
  const [loaded] = useScript('https://premmiardev.blob.core.windows.net/braspag-debit/braspag-debit-3ds.js', { id: 'braspagDebit' })
  return ''
}

export default BraspagAuthorize
